import * as React from "react";
import {
  Grid,
  Box,
  IconButton,
  Drawer,
  TextField,
  List,
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Divider,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchTeamEvents } from "../../api/apis";
import { getTeamsByEvent } from "../../api/teams";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalProvider";

async function GetTeamEvents(team) {
  const data = await fetchTeamEvents({ year: 2025, team: team });
  return data;
}

async function GetTeamsByEvent(event) {
  const data = await getTeamsByEvent((event = event));
  return data;
}

export default function QuickSearch() {
  const { eventList, teamList, setTargetAnalysisPage, addPage } = useGlobal();

  const [open, setOpen] = React.useState(false);
  const [resultsShown, setResultsShown] = useState(5);
  const [search, setSearch] = useState("");
  const [teamsEventList, setTeamsEventList] = useState({});
  const [eventsTeamsList, setEventsTeamsList] = useState({});

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleSearchChange = (search) => {
    setSearch(search);
  };

  const fetchRobotsEvents = async (team) => {
    if (!teamsEventList[team]) {
      const result = await GetTeamEvents(team);
      try {
        setTeamsEventList((prev) => ({
          ...prev,
          [team]: result,
        }));

        console.log(result);
      } catch (error) {
        console.error("Error parsing team data:", error);
        setTeamsEventList([]);
      }
    }
  };

  const fetchEventsRobots = async (eventCode) => {
    try {
      const result = await GetTeamsByEvent(eventCode);
      const sortedTeams = result.sort((a, b) => a.team_number - b.team_number);
      setEventsTeamsList((prev) => ({
        ...prev,
        [eventCode]: sortedTeams,
      }));
    } catch (error) {
      console.error("Error parsing team data:", error);
      setEventsTeamsList([]);
    }
  };

  const navigate = useNavigate();

  const MainSearchList = (
    <Box sx={{ minWidth: 250, width: window.innerWidth / 2, maxWidth: 700 }}>
      <Grid container sx={{ width: "100%" }}>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            width: "100%",
          }}
        >
          <TextField
            name="searchTeam"
            label="Search"
            variant="filled"
            sx={{ width: "90%" }}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </Grid>
        <Divider sx={{ borderWidth: 3 }} />
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", mt: 2 }}
        >
          <List sx={{ width: "100%" }}>
            <ListItem key={0} sx={{ width: "100%" }}>
              Teams
            </ListItem>
            {teamList
              .filter(
                (team) =>
                  team.team_number.toString().includes(search) ||
                  team.team_name
                    .toLowerCase()
                    .replace(/\./g, "")
                    .trim()
                    .includes(search.toLowerCase().replace(/\./g, "").trim())
              )
              .slice(0, resultsShown)
              .map((team) => (
                <ListItem key={team.team_number} sx={{ width: "100%" }}>
                  <Accordion
                    sx={{
                      width: "100%",
                    }}
                    onClick={() => {
                      fetchRobotsEvents(team.team_number);
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={team.team_number}
                      id={team.team_number}
                    >
                      {team.team_number} - {team.team_name}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            m: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => {
                              addPage(`Team-${team.team_number}`);
                              setTargetAnalysisPage("overview");
                              navigate(`/analysis/team/${team.team_number}`);
                            }}
                            sx={{ width: "90%" }}
                          >
                            Overview
                          </Button>
                        </Grid>
                        {teamsEventList[team.team_number]
                          ?.filter((event) => event.eventCode != "test")
                          .map((event) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                p: 1,
                              }}
                            >
                              <Button
                                variant="contained"
                                onClick={() => {
                                  addPage(
                                    `TeamEvent-${team.team_number}-${event.value}`
                                  );
                                  setTargetAnalysisPage("overview");
                                  navigate(
                                    `/analysis/event/${event.value}/team/${team.team_number}`
                                  );
                                }}
                                sx={{ width: "90%" }}
                              >
                                {event.eventCode.toUpperCase()}
                              </Button>
                            </Grid>
                          ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </ListItem>
              ))}
            <Divider sx={{ borderWidth: 3 }} />
            <ListItem key={-1} sx={{ width: "100%" }}>
              Events
            </ListItem>
            {eventList
              .filter((event) => {
                const { label, location, value, week, district } = event;

                const cleanSearch = (search ?? "")
                  .toLowerCase()
                  .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

                const matchesSearch = [label, location, value, week].some(
                  (field) =>
                    (field ?? "")
                      .toLowerCase()
                      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                      .includes(cleanSearch)
                );

                return matchesSearch && event.week != "Testing";
              })
              .slice(0, resultsShown)
              .map((event) => (
                <ListItem key={event.value} sx={{ width: "100%" }}>
                  <Accordion
                    sx={{ width: "100%" }}
                    onClick={() => {
                      fetchEventsRobots(event.value);
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={event.name}
                      id={event.name}
                    >
                      {event.name}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            m: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => {
                              addPage(`Event-${event.value}`);
                              setTargetAnalysisPage("overview");
                              navigate(`/analysis/event/${event.value}`);
                            }}
                            sx={{ width: "90%" }}
                          >
                            Overview
                          </Button>
                        </Grid>
                        {eventsTeamsList[event.value]?.map((team) => (
                          <Grid
                            item
                            xs={6}
                            sm={4}
                            md={3}
                            xl={2}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              p: 1,
                            }}
                          >
                            <Button
                              variant="contained"
                              onClick={() => {
                                addPage(
                                  `TeamEvent-${team.team_number}-${event.value}`
                                );
                                setTargetAnalysisPage("overview");
                                navigate(
                                  `/analysis/event/${event.value}/team/${team.team_number}`
                                );
                              }}
                              sx={{ width: "90%" }}
                            >
                              <b>{team.team_number}</b>
                            </Button>
                          </Grid>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </ListItem>
              ))}
          </List>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          maxWidth: 48,
          maxHeight: 48,
        }}
      >
        <IconButton
          sx={{
            width: "100%",
            height: "100%",
            padding: 0,
          }}
          onClick={toggleDrawer(true)}
        >
          <SearchIcon sx={{ fontSize: "calc(2 * 100%)", color: "#fff" }} />
        </IconButton>
      </Box>
      <Drawer
        anchor="left"
        open={open}
        onOpen={toggleDrawer(true)}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            backgroundColor: "background.main",
          },
        }}
      >
        {MainSearchList}
      </Drawer>
    </>
  );
}
